(function () {
  function initFaq(container) {
    var questions = container.querySelectorAll('.faq-section__question');

    if (!questions.length) return;

    questions.forEach(function (btn) {
      btn.removeEventListener('click', btn._faqHandler);

      btn._faqHandler = function () {
        var isExpanded = this.getAttribute('aria-expanded') === 'true';
        var itemsWrapper = this.closest('.faq-section__items');

        itemsWrapper.querySelectorAll('.faq-section__item').forEach(function (item) {
          item.classList.remove('is-open');
          item.querySelector('.faq-section__question')
            .setAttribute('aria-expanded', 'false');
        });

        if (!isExpanded) {
          this.setAttribute('aria-expanded', 'true');
          this.closest('.faq-section__item').classList.add('is-open');
        }
      };

      btn.addEventListener('click', btn._faqHandler);
    });
  }

  function initAll() {
    document.querySelectorAll('.faq-section').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.faq-section');
    if (section) initFaq(section);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var section = e.target.closest('.faq-section');
    if (section) initFaq(section);
  });

})();